import React, { Component } from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import { Switch, Redirect } from 'react-router';
import Helmet from 'react-helmet';
import { TypographyStyle, GoogleFont } from 'react-typography';

import typography from './utils/typography';
import ScrollToTop from './utils/scrollToTop';
import TopNavContainer from './containers/TopNav';
import Home from './pages/Home';
import LoadableCV from './loadables/LoadableCV';
import LoadableAbout from './loadables/LoadableAbout';
import LoadableContact from './loadables/LoadableContact';
import LoadableJobDescription from './loadables/LoadableJobDescription';
import LoadableCommunityGardens from './loadables/LoadableCommunityGardens';
import LoadableBlom from './loadables/LoadableBlom';
import LoadableBlomArchive from './loadables/LoadableBlomArchive';
import LoadableUnionSquare from './loadables/LoadableUnionSquare';
import LoadableLightblades from './loadables/LoadableLightblades';
import LoadableIntergalactic from './loadables/LoadableIntergalactic';
import LoadableSketches from './loadables/LoadableSketches';
import LoadableImmersiveScholar from './loadables/LoadableImmersiveScholar';
import LoadableNFTs from './loadables/LoadableNFTs';
import NewsletterSignup from './containers/NewsletterSignup';
import Bio from './containers/Bio';
import NotFound from './components/NotFound';

import './App.css';

class App extends Component {
  componentWillUpdate({ location, history }) {
    const gtag = window.gtag;

    if (location.pathname === this.props.location.pathname) {
      return;
    }

    if (history.action === 'PUSH' && typeof gtag === 'function') {
      gtag('config', 'UA-117743172-1', {
        page_location: window.location.href,
        page_path: location.pathname,
      });
    }
  }
  render() {
    return (
      <div className="App">
        <Helmet
          title="Generative Artist: lucastswick"
          description="lucastswick is a generative artist writing algorithms that describe natural phenomena."
        />
        <TypographyStyle typography={typography} />
        <GoogleFont typography={typography} />
        <Router>
          <div id="outer-container">
            <TopNavContainer />
            <div id="page-wrap">
              <ScrollToTop>
                <Switch>
                  <Route exact path="/" component={Home} />
                  <Route path="/about" component={LoadableAbout} />
                  <Route path="/cv" component={LoadableCV} />
                  <Route path="/contact" component={LoadableContact} />
                  <Route
                    path="/what-i-do-at-easykicks"
                    component={LoadableJobDescription}
                  />
                  <Route
                    path="/immersive-scholar"
                    exact
                    component={LoadableImmersiveScholar}
                  />
                  <Route
                    path="/immersive-scholar-residency-at-NCSU"
                    exact
                    component={LoadableImmersiveScholar}
                  />
                  <Route path="/nfts" exact component={LoadableNFTs} />
                  <Switch>
                    <Route
                      exact
                      path="/work"
                      render={() => <Redirect to="/" />}
                    />
                    <Route
                      exact
                      path="/work/community-gardens"
                      render={() => (
                        <Redirect to="/work/community-gardens-a-data-driven-generative-art-installation-about-housing-insecurity-at-ncsu" />
                      )}
                    />
                    <Route
                      path="/work/community-gardens-a-data-driven-generative-art-installation-about-housing-insecurity-at-ncsu"
                      exact
                      component={LoadableCommunityGardens}
                    />
                    <Route
                      exact
                      path="/work/blom"
                      render={() => (
                        <Redirect to="/work/blom-a-generative-art-series" />
                      )}
                    />
                    <Route
                      exact
                      path="/blom"
                      render={() => (
                        <Redirect to="/work/blom-a-generative-art-series" />
                      )}
                    />
                    <Route
                      path="/work/blom-a-generative-art-series"
                      exact
                      component={LoadableBlom}
                    />
                    <Route
                      exact
                      path="/work/union-square"
                      render={() => (
                        <Redirect to="/work/generative-art-installation-in-union-square" />
                      )}
                    />
                    <Route
                      path="/work/generative-art-installation-in-union-square"
                      exact
                      component={LoadableUnionSquare}
                    />
                    <Route
                      exact
                      path="/work/lightblades"
                      render={() => (
                        <Redirect to="/work/lightblades-installation-at-the-geode-in-portland" />
                      )}
                    />
                    <Route
                      path="/work/lightblades-installation-at-the-geode-in-portland"
                      exact
                      component={LoadableLightblades}
                    />
                    <Route
                      path="/work/sketches"
                      exact
                      component={LoadableSketches}
                    />
                    <Route
                      path="/work/intergalactic"
                      exact
                      component={LoadableIntergalactic}
                    />
                    <Route
                      path="/work/intergalactic-a-generative-art-photographic-collaboration-with-costume-maker-wendi-anderson"
                      exact
                      component={LoadableIntergalactic}
                    />

                    <Route
                      exact
                      path="/archive"
                      render={() => (
                        <Redirect to="/archive/blom-a-generative-art-series" />
                      )}
                    />
                    <Route
                      path="/archive/blom-a-generative-art-series"
                      exact
                      component={LoadableBlomArchive}
                    />

                    <Route component={NotFound} />
                  </Switch>
                  <Route component={NotFound} />
                </Switch>
                <NewsletterSignup />
                <Bio />
              </ScrollToTop>
            </div>
          </div>
        </Router>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js